import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import cookie from "react-cookies";

const AuthenticatedRoute = ({ component: Component, ...rest}) => {
  // let token = cookie.load("_mkdtoken");

  return <Route {...rest} render= {(props) => (
    cookie.load("_mkdtoken") !== undefined 
      ? <Component {...props} />  
      : <Redirect to="/login" />
  )}/>
}

export default AuthenticatedRoute;


// WEBPACK FOOTER //
// ./src/containers/AuthenticatedRoute.js